'use client'
import React from 'react'
import { deleteCookie } from '@/actions/coockiesActions'
import CustomButton from '@/components/common/CustomButton'
import { signOut } from 'firebase/auth';
import { auth } from '@/services/firebase.service';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

const SignOut = ({ setAuthVisible }) => {

  const router = useRouter()

  const isLocal = process.env.NODE_ENV === "development";

  const logOut = async () => {
    await signOut(auth)
    await deleteCookie('session')
    setAuthVisible({ open: false, step: null })
    toast.success('Has cerrado sesión exitosamente')
    if (isLocal)
      return router.push('/auth/login')

    return router.push('https://marinebroker.com.ar')
  }

  return (
    <article className='h-auto w-auto max-h-[700px] flex flex-col items-center gap-y-6 bg-white'>
      <h3 className='font-semibold text-2xl text-center'>Cerrar sesión</h3>
      <p className='text-base font-medium text-center'>Esta seguro que desea cerrar sesión? <br /> Puedes volver a iniciar sesión nuevamente cuando lo desees.</p>
      <div className='flex items-center gap-x-4'>
        <CustomButton title='Volver' action={() => setAuthVisible({ open: false, step: null })} colorType='primary' />
        <CustomButton title='Cerrar sesión' action={logOut} />
      </div>
    </article>
  )
}

export default SignOut